import axios, { mockData } from '@/utils/axios'

// 获取3s克隆sku信息
export const get3sClonePayInfoByKey = ({ key }) => {
  return axios.get(`/apis/moyin-account/v1/trc/market/order/sms/info?key=${key}`)
}

// 获取3s克隆sku信息
export const create3sCloneOrder = (data) => {
  return axios.post(`/apis/moyin-account/v1/trc/market/order`, data)
}


